import Vue from 'vue'
import VueRouter from 'vue-router';
import { BootstrapVue, BootstrapVueIcons  } from 'bootstrap-vue';
import VueFeather from 'vue-feather';
import vWow from 'v-wow';
import VueCarousel from 'vue-carousel';
import Toasted from 'vue-toasted';
import '@/assets/style/custom.scss';
import App from './App.vue'
import i18n from './i18n'
import router from "./router";
import store from './store/store'
import axios from 'axios'
import VueMeta from 'vue-meta'
import { client } from "@/store/client.js";
import VuePusher from './pusher'
import Vue2Filters from 'vue2-filters'
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import de from "vee-validate/dist/locale/de.json";
import * as rules from "vee-validate/dist/rules";
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize("de", de);

Vue.config.productionTip = false

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueFeather);
Vue.use(VueRouter);
Vue.use(vWow);
Vue.use(VueCarousel);
Vue.use(Toasted)
Vue.use(VueMeta)
Vue.component('ValidationProvider', ValidationProvider,)
Vue.component('ValidationObserver', ValidationObserver,)
Vue.use(Vue2Filters)

Vue.use(VuePusher, {
  api_key: process.env.VUE_APP_PUSHER_APP_KEY,
  options: {
    cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
    encrypted: true,
    logToConsole: true
    /* authEndpoint: `${process.env.VUE_APP_API_URL}/api/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${store.state.auth.token}`
      }
    } */
  }
})

let i18ninstance = i18n()

const userInfo = localStorage.getItem('current_user')
const userData = JSON.parse(userInfo)
    if (userData) {            
      axios.defaults.headers.common["Authorization"] = `Bearer ${userData.token}`
      client.coreapi.defaults.headers.common["Authorization"] = `Bearer ${userData.paytoken}`
      store.dispatch('accountsModule/checkAuth', userData).then(() => {
        
        const app = new Vue({
          el: '#app',
          store,
          router,
          i18n: i18ninstance,
          mixins: [
            Vue2Filters.mixin
          ],
          created() {    
            axios.interceptors.response.use(
              response => response,
              error => {
                console.log(error)
                if (error.status === 401) {
                  store.dispatch('accountsModule/logout')
                }
                return Promise.reject(error)
              }
            )
          },
          metaInfo: () => ({
            title: 'myDESER',
            titleTemplate: '%s | Verwertungsnachweis Software',
            htmlAttrs: {
              lang: 'de',
              amp: undefined
            },
            headAttrs: {
              test: true
            },
            bodyAttrs: {
              tabIndex: 0
            },
            meta: [
              { name: 'robots', content: 'index,follow', vmid: 'rob' },
              { name: 'description', content: 'Beschreiten Sie neue Wege in der Autoverwertung. Die neue Software-Generation für Ihr Unternehmen.', vmid: 'desc' },
              { name: 'keywords', content: 'Verwertungsnachweis', vmid: 'key' },
            ],
            script: [
              { innerHTML: '{ "@context": "http://www.schema.org", "@type": "Organization" }', type: 'application/ld+json' },
              { innerHTML: '{ "body": "yes" }', body: true, type: 'application/ld+json' }
            ],
            __dangerouslyDisableSanitizers: ['script']
          }),
          render: h => h(App),
        }).$mount('#app')
      })
    } else {
      
      const app = new Vue({
        el: '#app',
        store,
        router,
        i18n: i18ninstance,
        mixins: [
          Vue2Filters.mixin
        ],
        created() {    
          axios.interceptors.response.use(
            response => response,
            error => {
              console.log(error)
              if (error.status === 401) {
                store.dispatch('accountsModule/logout')
              }
              return Promise.reject(error)
            }
          )
        },
        metaInfo: () => ({
          title: 'myDESER',
          titleTemplate: '%s | Verwertungsnachweis Software',
          htmlAttrs: {
            lang: 'de',
            amp: undefined
          },
          headAttrs: {
            test: true
          },
          bodyAttrs: {
            tabIndex: 0
          },
          meta: [
            { name: 'robots', content: 'index,follow', vmid: 'rob' },
            { name: 'description', content: 'Beschreiten Sie neue Wege in der Autoverwertung. Die neue Software-Generation für Ihr Unternehmen.', vmid: 'desc' },
            { name: 'keywords', content: 'Verwertungsnachweis', vmid: 'key' },
          ],
          script: [
            { innerHTML: '{ "@context": "http://www.schema.org", "@type": "Organization" }', type: 'application/ld+json' },
            { innerHTML: '{ "body": "yes" }', body: true, type: 'application/ld+json' }
          ],
          __dangerouslyDisableSanitizers: ['script']
        }),
        render: h => h(App),
      }).$mount('#app')
    }

